<template>
  <v-row>
    <v-col cols="12">
      <v-card class="txnv-card" flat>
        <!-- ================= HEADER BAND ================= -->
        <div class="txnv-header pl-base-bg">
          <div class="txnv-header-left">
            <div class="txnv-header-icon">
              <v-icon color="#fff" size="22">mdi-swap-horizontal</v-icon>
            </div>
            <div>
              <div class="txnv-title">Transaction</div>
              <div class="txnv-subtitle">
                Created on {{ formatDate(transaction?.date) }}
              </div>
            </div>
          </div>

          <v-chip
            :color="typeColor(transaction?.type)"
            dark
            small
            class="text-uppercase font-weight-bold"
          >
            {{ transaction?.type }}
          </v-chip>
        </div>

        <div class="pa-6">
          <!-- ================= DETAILS ================= -->
          <v-row>
            <!-- LEFT -->
            <v-col cols="12" md="6">
              <div class="txnv-detail-card">
                <div class="txnv-detail-label">Customer / Vendor</div>
                <div class="txnv-detail-value txnv-detail-value--lg">
                  {{ transaction?.customerName || "-" }}
                </div>

                <div class="txnv-detail-label mt-4">Category</div>
                <div class="txnv-detail-value">
                  {{ transaction?.category || "-" }}
                </div>

                <div class="txnv-detail-label mt-4">Payment Method</div>
                <div class="txnv-detail-value">
                  {{ transaction?.paymentMethod || "-" }}
                </div>
              </div>
            </v-col>

            <!-- RIGHT -->
            <v-col cols="12" md="6">
              <div
                class="txnv-amount-card"
                :class="transaction?.type === 'INCOME' ? 'txnv-amount-card--income' : 'txnv-amount-card--expense'"
              >
                <div class="txnv-amount-label">Amount</div>
                <div class="txnv-amount-value">
                  ₹ {{ formatCurrency(transaction?.amount) }}
                </div>

                <v-divider class="my-3 txnv-amount-divider" />

                <div class="txnv-amount-label">Note</div>
                <div class="txnv-note-value">
                  {{ transaction?.note || "-" }}
                </div>
              </div>
            </v-col>
          </v-row>

          <!-- ================= INVOICE LINK ================= -->
          <v-row class="mt-4" v-if="transaction?.invoiceId" no-gutters>
            <v-col cols="auto">
              <v-btn small class="txnv-invoice-btn" @click="goToInvoice">
                <v-icon left small>mdi-file-document</v-icon>
                View Invoice
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ViewTransaction",

  data() {
    return {
      transaction: null,
    };
  },

  async created() {
    const id = this.$route.params.id;

    this.transaction = await this.$store.dispatch(
      "transactions/getTransaction",
      id,
    );
  },

  methods: {
    formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },

    formatCurrency(val) {
      if (!val) return "0.00";
      return new Intl.NumberFormat("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(val);
    },

    typeColor(type) {
      if (type === "INCOME") return "green";
      if (type === "EXPENSE") return "red";
      return "grey";
    },

    goToInvoice() {
      if (!this.transaction?.invoiceId) return;

      this.$router.push(`/invoices/${this.transaction.invoiceId}/view`);
    },
  },
};
</script>

<style scoped>
.txnv-card {
  border-radius: 0;
  overflow: hidden;
  box-shadow: 0 6px 24px rgba(15, 30, 50, 0.1);
}

/* ================= HEADER BAND ================= */
.txnv-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 20px;
}

.txnv-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.txnv-header-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.txnv-title {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.01em;
}

.txnv-subtitle {
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.75);
  margin-top: 2px;
}

/* ================= DETAIL CARD ================= */
.txnv-detail-card {
  background: #f8fafc;
  border: 1px solid #eef1f5;
  border-radius: 0;
  padding: 18px 20px;
  height: 100%;
}

.txnv-detail-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
  margin-bottom: 4px;
}

.txnv-detail-value {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.txnv-detail-value--lg {
  font-size: 19px;
  font-weight: 700;
  color: #0f172a;
}

/* ================= AMOUNT CARD ================= */
.txnv-amount-card {
  border-radius: 0;
  padding: 18px 20px;
  height: 100%;
  color: #fff;
}

.txnv-amount-card--income {
  background: linear-gradient(135deg, #052f5e 0%, #0a5a90 100%);
}
.txnv-amount-card--expense {
  background: linear-gradient(135deg, #7a1f1f 0%, #b23a3a 100%);
}

.txnv-amount-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: rgba(255, 255, 255, 0.75);
}

.txnv-amount-value {
  font-size: 30px;
  font-weight: 700;
  letter-spacing: -0.01em;
  margin-top: 4px;
}

.txnv-amount-divider {
  border-color: rgba(255, 255, 255, 0.2) !important;
}

.txnv-note-value {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  margin-top: 4px;
}

/* ================= ACTIONS ================= */
.txnv-invoice-btn {
  background: var(--pl-base-bg-gradient) !important;
  color: #fff !important;
  font-weight: 700 !important;
  text-transform: none !important;
  box-shadow: none !important;
}
</style>
